/**
 * @generated SignedSource<<87e9765810aeaa5eba192be283c433a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageEditTabs_package$data = {
  readonly allDates: {
    readonly pageInfo: {
      readonly total: number;
    };
  };
  readonly media: {
    readonly pageInfo: {
      readonly total: number;
    };
  };
  readonly " $fragmentSpreads": FragmentRefs<"EntityHistory_entity" | "MediaEditor_mediable" | "PackageEditAccommodation_package" | "PackageEditDates_package" | "PackageEditMain_package" | "PackageEditTransport_package" | "SeoTab_seoable">;
  readonly " $fragmentType": "PackageEditTabs_package";
};
export type PackageEditTabs_package$key = {
  readonly " $data"?: PackageEditTabs_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditTabs_package">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 2147483647
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "total",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageEditTabs_package",
  "selections": [
    {
      "alias": "allDates",
      "args": (v0/*: any*/),
      "concreteType": "PackageDateConnection",
      "kind": "LinkedField",
      "name": "tripDates",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "tripDates(first:2147483647)"
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "concreteType": "MediaConnection",
      "kind": "LinkedField",
      "name": "media",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "media(first:2147483647)"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MediaEditor_mediable"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageEditMain_package"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageEditTransport_package"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageEditAccommodation_package"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageEditDates_package"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SeoTab_seoable"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntityHistory_entity"
    }
  ],
  "type": "Package",
  "abstractKey": null
};
})();

(node as any).hash = "7a41935f1f62dfd2bd46ba99d6784cbf";

export default node;
